<template>
  <div class="tabs" data-testid="tabs-discovery">
    <button
      v-for="btn in listBtns"
      :key="btn.id"
      :id="btn.id"
      :class="{ active: activedBtn === btn.id }"
      @click="selectTab(btn.id)"
      :data-testid="`tab-${btn.id}`"
    >
      <i :class="btn.icon"/>
      <span class="tabs__label">{{ translate(btn.label) }}</span>
    </button>
  </div>
</template>

<script>
// TODO: Move this component to common
export default {
  emits: ['selectComponent'],
  props: {
    activedSection: {
      type: String,
      required: true
    }
  },
  data: () => ({
    activedBtn: '',
    listBtns: [
      {
        id: 'list',
        label: 'promoList',
        icon: 'rhg-font-icon--list',
        order: 0
      },
      {
        id: 'map',
        label: 'promoMap',
        icon: 'rhg-font-icon--location',
        order: 1
      }
    ]
  }),
  methods: {
    selectTab(id) {
      this.activedBtn = id
    }
  },
  watch: {
    activedBtn: {
      handler(btnId) {
        this.$emit('selectComponent', btnId)
      },
      immediate: true
    }
  },
  mounted() {
    this.activedBtn = this.activedSection
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  max-width: 18rem;
  min-width: 10rem;
  background: color('light-grey');
  margin: 10px;
  border-radius: 4rem;
  padding: 0.7rem;
  @media (min-width: media('tablet-l')) {
    margin-right: 0;
  }

  &__label {
    margin-left: 0.5rem;
    @media (max-width: 575px) {
      display: none;
    }
  }
}

button {
  border: 0;
  background: color('light-grey');
  font-weight: bold;
  padding: 1rem;
  border-radius: 2rem;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
}

button:hover {
  background: color('grey-light');
  color: white;
}

.active,
.active:hover {
  background: color('black-discovery');
  color: white;
}
.icon-hamburger-menu {
  margin-top: 0.55rem;
}
</style>
